// 一つのVOCファイルの最大サイズ
const ONE_VOC_FILE_MAX_SIZE = 1024 * 1024 * 100; // 100MB
// 一度にアップロードできる最大ファイル数
const ONCE_TIME_UPLOAD_MAX_FILES = 5;

export { ONCE_TIME_UPLOAD_MAX_FILES, ONE_VOC_FILE_MAX_SIZE };
